<div class="project-side-panel">
  <mat-icon class="close-dialog" color="primary" mat-dialog-close>close</mat-icon>
  <h2 class="px-3" mat-dialog-title>{{ isEditMode ? "Edit Project" : "Add Project" }}</h2>
  <mat-dialog-content>
    <p class="px-3">{{ isEditMode ? "Edit" : "Add new" }} project for the engagement(s)</p>

    <form [formGroup]="projectForm">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Project Title</mat-label>
              <input matInput placeholder="Project Title" formControlName="title" maxlength="255" />
              <mat-error *ngIf="projectForm.get('title')?.hasError('forbiddenCharacters')">
                No forbidden characters are allowed.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Project Type</mat-label>
              <mat-select #projectType [matTooltip]="projectType.triggerValue" formControlName="type">
                <mat-option *ngFor="let projectType of projectTypes | sort : 'name'" [value]="projectType.id">
                  {{ projectType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Engagement Code</mat-label>
              <input #input
                     type="text"
                     matInput
                     placeholder="Engagement Code"
                     formControlName="engagement"
                     (blur)="validateEngagementObject()"
                     [matAutocomplete]="engagementAuto" />
              <mat-icon color="primary" matSuffix [class.disabled-opacity]="data && !data.isProjectAdmin">search</mat-icon>
              <mat-autocomplete #engagementAuto="matAutocomplete"
                                (optionSelected)="onSelectedEngagement()"
                                [displayWith]="displayEngagementsWith">
                <mat-option *ngIf="isEngagementsLoading" [disabled]="true">Loading...</mat-option>
                <mat-option *ngFor="let engagement of filteredEngagements" [value]="engagement">
                  {{
                engagement.engagementNumber
                  }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Industry</mat-label>
              <input matInput placeholder="Industry" formControlName="industry" maxlength="255" />
              <mat-error *ngIf="projectForm.get('industry')?.hasError('forbiddenCharacters')">
                No forbidden characters are allowed.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Opportunity Code</mat-label>
              <input matInput
                     (change)="onChangeOpportunityCode()"
                     placeholder="Opportunity Code"
                     formControlName="opportunityCode"
                     maxlength="255"
                     pattern="[a-zA-Z0-9]*" />
              <mat-error *ngIf="projectForm.get('opportunityCode')?.hasError('pattern')">
                Opportunity Code can only contain letters and numbers.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Service Line</mat-label>
              <input matInput placeholder="Service Line" formControlName="serviceLine" maxlength="255" />
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Client Name</mat-label>
              <input matInput placeholder="Client Name" formControlName="clientName" maxlength="255" />
            </mat-form-field>
          </div>
          <div class="col-12">
            <app-ad-users-autocomplete [disabled]="!!projectForm.controls['engagement'].value"
                                       [user]="projectForm.controls['leadPartner']"
                                       label="Lead Partner"
                                       placeholder="Lead Partner"
                                       classNames="w-100"></app-ad-users-autocomplete>
          </div>
          <div class="col-12">
            <app-ad-users-autocomplete [disabled]="!!projectForm.controls['engagement'].value"
                                       [user]="projectForm.controls['leadDirector']"
                                       label="Lead Director"
                                       placeholder="Lead Director"
                                       classNames="w-100"></app-ad-users-autocomplete>
          </div>
          <div class="col-12">
            <app-ad-users-autocomplete [user]="projectForm.controls['itsLead']"
                                       label="ITS Lead"
                                       placeholder="ITS Lead"
                                       classNames="w-100"></app-ad-users-autocomplete>
          </div>
          <div class="col-12">
            <app-ad-users-autocomplete [disabled]="!userService.userHasPlatformAdminRole"
                                       [user]="projectForm.controls['projectAdmin']"
                                       [isProjectAdmin]="true"
                                       label="Project Admin"
                                       placeholder="Project Admin"
                                       classNames="w-100"></app-ad-users-autocomplete>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close class="cancel">Cancel</button>
    <button (click)="addOrUpdateProject()"
            [disabled]="!projectForm.valid || preventDoubleClick"
            mat-flat-button
            color="primary"
            [class.disabled-opacity]="!projectForm.valid"
            *ngIf="!isEditMode || (isEditMode && displayButton)">
      <img [ngSrc]="isEditMode ? './assets/images/icons/save.svg' : './assets/images/icons/plus-icon.svg'"
           height="16"
           width="16"
           alt="{{ isEditMode ? 'Save icon' : 'Add icon' }}" />
      {{ isEditMode ? "Save Project" : "Add Project" }}
    </button>
  </mat-dialog-actions>
</div>
